import {
	requestRegistGrave,
	requestDeleteGrave
} from "@/apis/grave_api";
import router from "@/router";

const state = {
    graveList:[],
};

const getters = {
	getGraveList(state) {
		return state.graveList;
	},

};


const mutations = {
	GRAVE_LIST(state, data){
        state.graveList = data.resultGrave
	},
	INIT_GRAVE(state){
		state.graveList= []

	}
};

const actions = {
	
	async REQUEST_REGIST_GRAVE(context,parameter){
		try {
			context.commit('START_LOADING');
            const response = await requestRegistGrave(parameter.grave);
			if (response.data !== null && response.data !== undefined && response.data.result === 'success') {
				context.commit("GRAVE_LIST", response.data);
			} else {
				alert(response.data.message);
			}
			context.commit('END_LOADING');
		} catch (e) { if(e==='refresh'){ return }
			context.commit('END_LOADING');
			context.commit("OPEN_MODAL", {
				title: "회원가입에 실패",
				content: e.response.data.message,
				option1: "닫기"
			});
			alert('네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다.');
		}
	},
	async REQUEST_DELETE_GRAVE(context,parameter){
		try {
			context.commit('START_LOADING');
            const response = await requestDeleteGrave(parameter.id);
			if (response.data !== null && response.data !== undefined && response.data.result === 'success') {
				context.commit("GRAVE_LIST", response.data);
			} else {
				alert(response.data.message);
			}
			context.commit('END_LOADING');
		} catch (e) { if(e==='refresh'){ return }
			context.commit('END_LOADING');
			context.commit("OPEN_MODAL", {
				title: "회원가입에 실패",
				content: e.response.data.message,
				option1: "닫기"
			});
			alert('네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다.');
		}
	},
};

export default { mutations, state, actions, getters };